import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  isLoading: boolean = false;

  constructor() {}

  /**
   * ローディング開始
   */
  startLoading() {
    this.isLoading = true;
  }

  /**
   * ローディング停止
   */
  stopLoading() {
    this.isLoading = false;
  }
}
